import { render, staticRenderFns } from "./AsignacionAutocomplete.vue?vue&type=template&id=6850b2ac"
import script from "./AsignacionAutocomplete.vue?vue&type=script&lang=js"
export * from "./AsignacionAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports